import type { StatusMeta } from '../../services/workQueue';

// Every team a step can be owned by: its default owner plus any per-version owner.
export function possibleOwners(status: Pick<StatusMeta, 'team' | 'byVersion'>): string[] {
    const versionTeams = Object.values(status.byVersion ?? {}).map((fields) => fields.team);
    return [...new Set([status.team, ...versionTeams])];
}
